module.exports = __webpack_public_path__ + "bf8f02c3647ccf0b202bcf61ba41544a.svg";